module.exports = __webpack_public_path__ + "static/media/logo@2x.413981c5.png";